import i18n from 'i18next';
import styles from '../../../sass/components/PaymentErrorBanner.module.scss';
import {useReducer} from "react";
import EditPaymentDetailsModal from "@/Pages/Manage/EditPaymentDetailsModal";
import {ButtonPrimary} from "@/Components/Buttons/ButtonPrimary";

function reducer(state, action) {
    switch(action.type) {
        case "editPaymentDetailsModal":
            return { ...state, editPaymentDetailsModal: action.payload.editPaymentDetailsModal }
        default:
            return state;
    }
}

export function PaymentErrorBanner({failedPayment}) {

    const [state, dispatch] = useReducer(reducer,
        {
            editPaymentDetailsModal: false
        });

    return (
        failedPayment && <ButtonPrimary className={styles.paymentErrorBanner} onClick={() => {
            window.location.href = "/manage/billing";
        }}>
            <div className={styles.paymentText}>
                {`${i18n.t("payment-error-banner.payment-failure")}`}
            </div>
            <div className={styles.upgrade}>{i18n.t("payment-error-banner.update")}
            </div>

            { state.editPaymentDetailsModal ? <EditPaymentDetailsModal state={state} dispatch={dispatch}/> : null }
        </ButtonPrimary>
    )
}
